import { z } from "zod";
import { gql } from "graphql-request";

export const Sys = z.object({
  id: z.string(),
  publishedAt: z.string().nullable(),
  firstPublishedAt: z.string().nullable(),
  publishedVersion: z.number().nullable(),
});

export type Sys = z.infer<typeof Sys>;

export const SysFragment = gql`
  fragment SysFragment on Sys {
    id
    publishedAt
    firstPublishedAt
    publishedVersion
  }
`;
